import React, { Component, useState, useRef, useEffect, useContext } from "react";
import { Icon, Accordion } from 'semantic-ui-react'
import { useHistory, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { getFaqs } from "../../store/OrderRedux";
import { Config } from "../../common"
import { Loading } from "../../components"

const FaqScreen = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(1)
  const token = useSelector((state) => state.auth.token)
  const faqs = useSelector((state) => state.order.faqs)
  const isFetching = useSelector((state) => state.order.isFetching)
  const [icon, setIcon] = useState(true)

  useEffect(() => {
    dispatch(getFaqs({ token }));
    window.scrollTo(0, 0)
  }, []);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex)
    if (icon) {
      setIcon(false)
    } else {
      setIcon(true)
    }
  }


  return (
    <div className="container-fluid bg clearall">
      <div className="industry">
        <h4>THow can we <span> Help you?</span></h4>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
      </div>
      {isFetching && (<Loading />)}
      <div className="accordion_sec">
        <Accordion>
          {faqs ? faqs.map((item, key) => {
            let newItem = Config.GetLanguageSameLine(item, i18n.language)
            return <div key={key} className="background_sec">
              <Accordion.Title
                active={activeIndex === key}
                index={key}
                onClick={handleClick}
              >

                {activeIndex === key ? <Icon name="angle down" className="faq-icon" /> : <Icon name="angle up" className="faq-icon" />}
                <span>{newItem.question}</span>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === key}>
                <div className="faq_border"></div>

                <p>
                  {newItem.answer}
                </p>
              </Accordion.Content>
            </div>
          }) : null}




        </Accordion>
      </div>
    </div>
  )
}
export default FaqScreen